<template>
  <!-- ホルター心電図配送ｻｰﾋﾞｽ 自宅配送出荷実績シート -->
  <div id="HolterNumberOfShipmentSummary">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterNumberOfShipmentSummary"'></holterNavi>
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 自宅配送出荷実績シート</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>出荷日</th><td><input type="date" id="completionDateStart" v-model="shippingDate" :max="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
          </tr>
        </table>
        <b-button class="searchButton is-primary" @click="doSearch">検索</b-button>
      </div>
      <!-- 検索結果 -->
      <div v-if="hasResult">
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('holterNumberOfShipmentSummaryTable')">クリップボードにコピー</b-button>
        </div>
        <b-table
            id="holterNumberOfShipmentSummaryTable"
            :data="data">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="140" centered >{{props.row.receiptNumber}}</b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="120" centered >{{props.row.shippingDate}}</b-table-column>
              <b-table-column field="inspectionKind" label="機種名" width="100" >{{props.row.inspectionKind}}</b-table-column>
              <b-table-column field="serial" label="機器シリアル" width="130"  >{{props.row.serial}}</b-table-column>
              <b-table-column field="patch1" label="ディスポ電極パッチ　ロット①" width="130">{{props.row.patchlot1}}</b-table-column>
              <b-table-column field="patch2" label="ディスポ電極パッチ　ロット②" width="130">{{props.row.patchlot2}}</b-table-column>
              <b-table-column field="patch3" label="ディスポ電極パッチ　ロット③" width="130">{{props.row.patchlot3}}</b-table-column>
              <b-table-column field="dispoElectrodePatch5day" label="ディスポ電極パッチ 5日用" width="130">{{props.row.electrodePatch5}}</b-table-column>
              <b-table-column field="dispoElectrodePatch15day" label="ディスポ電極パッチ 15日用" width="140">{{props.row.electrodePatch15}}</b-table-column>
              <b-table-column field="leadWireAdapter" label="リードワイヤアダプター　ロット" width="160">N/A<!-- TODO: ローンチ時はN/Aで良い --></b-table-column>
              <b-table-column field="#1" label="清拭綿" width="70" centered >{{props.row.seishikimen}}</b-table-column>
              <b-table-column field="#2" label="症状イベント記録" width="130" centered >1</b-table-column>
              <b-table-column field="#3" label="患者用ガイド" width="70" centered >{{props.row.guide}}</b-table-column>
              <b-table-column field="InformationStatement" label="案内文" width="70" centered >1</b-table-column>
              <b-table-column field="#4" label="返送用封筒" width="70" centered >1</b-table-column>
              <b-table-column field="#5" label="返送用伝票" width="70" centered >1</b-table-column>
              <b-table-column field="paymentNumber" label="着払い伝票番号" width="100" centered >{{props.row.paymentNumber}}</b-table-column>
              <b-table-column field="invoiceNumber" label="送り状伝票番号" width="100" centered >{{props.row.invoiceNumber}}</b-table-column>
            </template>
        </b-table>
      </div>

    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holter/HolterNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "HolterNumberOfShipmentSummary",
  methods: {
    doSearch: function(){
      if(!this.shippingDate){
        this.showErrorMessage("出荷日を指定してください。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterDeliveryShippingRecordSheetPOST;
      var successCallBack = this.getHolterDeliveryShippingRecordSheetPOSTSuccess;
      var errorCallBack = this.getHolterDeliveryShippingRecordSheetPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterDeliveryShippingRecordSheetPOST: function(client) {
      return client.apis.internalHolter.getHolterDeliveryShippingRecordSheetPOST({
        body:{shippingDate:this.shippingDate.replace(/-/g, "/")}
      });
    },
    getHolterDeliveryShippingRecordSheetPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getHolterDeliveryShippingRecordSheetPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    clipboardCopy: function(elementId) {
      var btable = document.getElementById(elementId);
      var tbody = btable.getElementsByTagName("tbody")[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
        });
    }
  },
  data() {
    return {
      shippingDate:"",
      data: {},
      hasResult: false,
      atLaunchHidden: atLaunchHidden,
    };
  },
  components: {
    holterNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.conditionTable {
  width: 400px;
}
.searchButton {
    margin-left:20px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterNumberOfShipmentSummary.vue